// Routes.js
import { Route, Routes as RoutesDom, useLocation } from "react-router-dom";

import Home from "./pages/Home/Home";
import Login from "./pages/Login/Login";
import Stores from "./pages/Stores/Stores";
import ProductUpdate from "./pages/ProductUpdate/ProductUpdate";
import Commissions from "./pages/Commissions/Commissions";
import Installs from "./pages/Installs/Installs";
import StoreMap from "./pages/StoreMap/StoreMap";
import ESLs from "./pages/ESLs/ESLs";
import ESLDetails from "./pages/ESLDetails/ESLDetails";
import InsertESL from "./pages/InsertESL/InsertESL";
import InsertSGLN from "./pages/InsertSGLN/InsertSGLN";
import NotFound from "./pages/NotFound";
import Navbar from "./components/Navbar/Navbar";
import Register from "./pages/Register/Register";
import InserirAVRO from "./pages/InserirAVRO/InserirAVRO";

const Routes = () => {
  const location = useLocation();
  const token = localStorage.getItem("token");

  // Verifica se a rota atual é a de login
  const isLoginPage = location.pathname === "/login";
  const isRegisterPage = location.pathname === "/register";

  return (
    <>
      {!isLoginPage && !isRegisterPage && <Navbar />}
      {/* Se não for a rota de login, renderiza o Navbar */}
      {token ? (
        <RoutesDom>
          <Route index path="/home" element={<Home />} />
          <Route path="stores" element={<Stores />} />
          <Route path="productUpdate" element={<ProductUpdate />} />
          <Route path="installs" element={<Installs />} />
          <Route path="commissions" element={<Commissions />} />
          <Route path="storemap" element={<StoreMap />} />
          <Route path="esls" element={<ESLs />} />
          <Route path="details/:mac" element={<ESLDetails />} />
          <Route path="insertESL" element={<InsertESL />} />
          <Route path="insertSGLN" element={<InsertSGLN />} />
          <Route path="inserirAVRO" element={<InserirAVRO />} />
          <Route path="*" element={<NotFound />} />
        </RoutesDom>
      ) : (
        <RoutesDom>
          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />
          <Route path="*" element={<NotFound />} />
        </RoutesDom>
      )}
    </>
  );
};

export default Routes;
